import { useIntl } from "react-intl";
import { Icon } from "semantic-ui-react";
import ProductResultItem from "./ProductResultItem";

const ProductSearchDropdown = ({
  productSearch,
  selectedSkus,
  hoveredSkuId,
  setHoveredSkuId,
  toggleSkuSelection,
  onSelectAll,
}) => {
  const intl = useIntl();
  if (!productSearch.showResults || productSearch.query.length === 0) return null;

  let content;
  if (productSearch.query.length < 3) {
    content = (
      <div style={{ padding: "12px", textAlign: "center", color: "#888", fontSize: "13px" }}>
        {intl.formatMessage({
          id: "HINT_MIN_CHARS_TO_SEARCH",
          defaultMessage: "Type at least 3 characters to search...",
        })}
      </div>
    );
  } else if (productSearch.loading) {
    content = (
      <div style={{ padding: "12px", textAlign: "center", color: "#888", fontSize: "13px" }}>
        <Icon
          name="circle notch"
          loading
        />{" "}
        {intl.formatMessage({ id: "LABEL_SEARCHING_PRODUCTS", defaultMessage: "Searching products…" })}
      </div>
    );
  } else if (productSearch.results.length === 0) {
    content = (
      <div style={{ padding: "12px", textAlign: "center", color: "#888", fontSize: "13px" }}>
        {intl.formatMessage(
          { id: "LABEL_NO_PRODUCTS_FOUND", defaultMessage: "No products found for '{search}'" },
          { search: productSearch.query },
        )}
      </div>
    );
  } else {
    const allSelected = productSearch.results.every((item) => selectedSkus.some((s) => s.sku_id === item.sku_id));
    content = (
      <>
        <div
          style={{
            padding: "6px 12px",
            borderBottom: "1px solid #e0e1e2",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <button
            type="button"
            disabled={allSelected}
            onClick={onSelectAll}
            style={{
              background: "none",
              border: "none",
              cursor: allSelected ? "default" : "pointer",
              color: allSelected ? "#aaa" : "#2185d0",
              fontSize: "12px",
              padding: 0,
            }}
          >
            {allSelected
              ? intl.formatMessage({ id: "LABEL_ALL_SELECTED", defaultMessage: "All selected" })
              : intl.formatMessage({ id: "LABEL_SELECT_ALL", defaultMessage: "Select all" })}
          </button>
        </div>
        {productSearch.results.map((item) => (
          <ProductResultItem
            key={item.sku_id}
            item={item}
            isSelected={selectedSkus.some((s) => s.sku_id === item.sku_id)}
            isHovered={hoveredSkuId === item.sku_id}
            onToggle={toggleSkuSelection}
            onMouseEnter={() => setHoveredSkuId(item.sku_id)}
            onMouseLeave={() => setHoveredSkuId(null)}
          />
        ))}
      </>
    );
  }

  return (
    <div
      style={{
        position: "absolute",
        width: "100%",
        border: "1px solid #d4d4d5",
        borderTop: "none",
        borderRadius: "0 0 4px 4px",
        background: "#fff",
        maxHeight: "220px",
        overflowY: "auto",
        zIndex: 10,
        boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
      }}
    >
      {content}
    </div>
  );
};

export default ProductSearchDropdown;
